import {
    getAsset1ChangePct,
    getAssetId1,
    getAssetId2,
    getDeltaPercent,
    getFirstDate
} from "../../ducks/comparator-duck.js";
import {useSelector} from "react-redux";
import Counter from "../util/Counter.jsx";
import './ComparatorSummary.scss'
import {getDirectionColorClassName} from "../../util/misc.js";
import MinusThickIcon from "mdi-react/MinusThickIcon.js";
import PlusThickIcon from "mdi-react/PlusThickIcon.js";
import TimeDiff from "../util/TimeDiff.jsx";
import {getSpecificAsset} from "../../ducks/assets-duck.js";

export default () => {
    const deltaPct = useSelector(getDeltaPercent)
    const asset1ChangePct = useSelector(getAsset1ChangePct)
    const firstDate = useSelector(getFirstDate)
    const deltaClass = getDirectionColorClassName(deltaPct)
    const assetId1 = useSelector(getAssetId1)
    const assetId2 = useSelector(getAssetId2)
    const {code: code1} = useSelector(state => getSpecificAsset(state, assetId1))
    const {code: code2} = useSelector(state => getSpecificAsset(state, assetId2))
    const key = `${assetId1}-${assetId2}`
    const asset2ChangePct = asset1ChangePct - deltaPct
    return (
        <div className='comparator-summary'>
            {firstDate &&
            <>
                <KPI label='from' className='hide-portrait'>
                    {firstDate}
                </KPI>
                <KPI label='duration' className='hide-portrait'>
                    <TimeDiff date={firstDate} withoutSuffix={true}/>
                </KPI>
            </>
            }
            <KPI label={code1} className='asset-change'>
                <div className={`flex-vertical-center`}>
                    {asset1ChangePct < 0 ? <MinusThickIcon/> : <PlusThickIcon/>}
                    <Counter
                        key={key}
                        amount={asset1ChangePct}
                        decimals={2}
                        suffix='%'
                        absolute={true}
                        noColor={true}
                    />
                </div>
            </KPI>
            <KPI label={code2} className='asset-change'>
                <div className={`flex-vertical-center`}>
                    {asset2ChangePct < 0 ? <MinusThickIcon/> : <PlusThickIcon/>}
                    <Counter
                        key={key}
                        amount={asset2ChangePct}
                        decimals={2}
                        suffix='%'
                        absolute={true}
                        noColor={true}
                    />
                </div>
            </KPI>
            <KPI label='delta' className='delta-pct'>
                <div className={`flex-vertical-center ${deltaClass}`}>
                    {deltaPct < 0 ? <MinusThickIcon/> : <PlusThickIcon/>}
                    <Counter
                        key={key}
                        amount={deltaPct}
                        decimals={2}
                        suffix='%'
                        absolute={true}
                        noColor={true}
                    />
                </div>
            </KPI>
        </div>
    )
}

const KPI = ({className, label = 'kpi', children}) => {
    return (
        <div className={`kpi ${className}`}>
            <h4>
                {label}
            </h4>
            <div className='value'>
                {children}
            </div>
        </div>
    )
}